var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckboxIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.888264 6.22347C1.20591 5.58818 2.02308 5.39854 2.58806 5.829L4.29708 7.13111C4.69855 7.43699 5.26502 7.39576 5.61796 7.03497L11.7447 0.772037C12.1769 0.330254 12.8696 0.277201 13.364 0.648013C13.9636 1.09769 14.0259 1.97413 13.4959 2.50408L6.33347 9.66653C5.58468 10.4153 4.382 10.4507 3.59053 9.74714L1.14889 7.57679C0.766046 7.23649 0.659189 6.68162 0.888264 6.22347Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkbox_icon.0f4e853a8f5efbfd87e6788d2048c2d4.svg";